import { render, staticRenderFns } from "./GroupsLeagueMatches.vue?vue&type=template&id=3bdb38b0&scoped=true&"
import script from "./GroupsLeagueMatches.vue?vue&type=script&lang=js&"
export * from "./GroupsLeagueMatches.vue?vue&type=script&lang=js&"
import style0 from "./GroupsLeagueMatches.vue?vue&type=style&index=0&id=3bdb38b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb38b0",
  null
  
)

export default component.exports